import "@/styles/globals.css";
import { ApolloProvider } from "@apollo/client/react";
import type { AppProps } from "next/app";
import { Poppins } from "next/font/google";
import { Router } from "next/router";
import posthog from "posthog-js";
import { Suspense, useEffect, useMemo } from "react";
import FacebookPixel from "@/components/FacebookPixel";
import { KlaviyoScript } from "@/components/KlaviyoScript";
import { PodiumScript } from "@/components/PodiumScript";
import { SanityPopup } from "@/sanity/components/SanityPopup";
import { createApolloClient } from "@/util/apollo-client";

const poppins = Poppins({
  subsets: ["latin"],
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  variable: "--font-poppins",
});

export default function App({ Component, pageProps }: AppProps) {
  const client = useMemo(() => {
    return createApolloClient();
  }, []);

  useEffect(() => {
    const handleRouteChange = () => posthog.capture("$pageview");
    Router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  return (
    <ApolloProvider client={client}>
      <div className={poppins.className}>
        <Suspense fallback={"Loading..."}>
          <Component {...pageProps} />
        </Suspense>
      </div>
      <FacebookPixel />
      <KlaviyoScript />
      <PodiumScript />
      <SanityPopup popup={pageProps.popup} />
    </ApolloProvider>
  );
}
